module.exports = global.config = {
    base_url: "https://iot.gotani.com.my/",
    server_url: "https://www.gotani.com.my/"
};